import { createAction, createReducer } from "redux-act";

import { reducerRegistry } from "../reducerRegistry";

const reducerName = "chat";

export interface ChatState {
  active: boolean;
  width: number;
}

const initialState: ChatState = {
  active: false,
  width: 576,
};

export const reducer = createReducer<ChatState>({}, initialState);

export const setChatActive = createAction<boolean>(`${reducerName}/set-chat-active`);

export const setChatWidth = createAction<number>(`${reducerName}/set-chat-width`);

reducer.on(setChatActive, (state, payload) => ({
  ...state,
  active: payload,
}));

reducer.on(setChatWidth, (state, payload) => ({
  ...state,
  width: payload,
}));

reducerRegistry.register(reducerName, reducer);
